
    export interface IUsernameResult {
        userId: string;
        username: string;
        displayName: string;
    }

    export class UsernameResult implements IUsernameResult {
        userId: string;
        username: string;
        displayName: string;
    }